var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticStyle:{"height":"1px","visibility":"hidden"}},[_c('img',{attrs:{"src":require("../assets/eva-bubianli.jpg")}})]),_c('div',[_c('a',{attrs:{"href":"/"}},[_c('span',[_vm._v("B U B I A N L I 不 便 利")])])]),_c('div',{staticStyle:{"font-size":"12px","color":"#999"}},[_vm._v("Inconvenient")])])
}]

export { render, staticRenderFns }